export default {
  title: "Zvýrazněné produkty",
  label: "Nemáte žádné produkty označené.",
  message: `Zvýrazněné produkty se zobrazují v klastru v dolní části stránky a
  měly být využity pro produkty, které uživatel uvidí po projití celé stránky
  a tedy by měl být více nakloněni si je prohlédnout a koupit.`,
  select_product: "Přidat zvýrazněné produkty",
  demo_message: "Zde zobrazíme Vaše 'Zvýrazněné produkty'."
}
